const leaves = {
  tr: {
    teamLeavesPanel: { current: "Şu an izinli", upcoming: "Yaklaşan" },
    holidays: {
      loadError: "Tatiller yüklenemedi.",
      rangeInvalid: "Bitiş tarihi başlangıçtan önce olamaz.",
      deleteConfirm: "\"{{name}}\" ({{date}}) silinsin mi?",
    },
    holidaysPage: {
      tabs: { all: "Tümü", upcoming: "Yaklaşan", past: "Geçmiş" },
      search: "Tatil adı ara...",
      month: "Ay",
      allMonths: "Tüm aylar",
      weekday: "Gün",
      weekend: "Hafta sonu",
    },
    leaveTypesPage: {
      tabs: { all: "Tümü", daily: "Günlük", hourly: "Saatlik", affects: "Bakiyeden düşen", noAffect: "Bakiyeyi etkilemeyen" },
      search: "İzin türü adı veya açıklama ara...",
      sortNameAsc: "Ad (A → Z)",
      sortNameDesc: "Ad (Z → A)",
      nameRequired: "İzin türü adı zorunludur.",
    },
    myTeamPage: {
      tabs: { all: "Tüm ekip", onLeave: "Yakında izinli", lowBalance: "Düşük bakiye (≤3 gün)" },
      search: "Ad, kullanıcı adı veya birim ara...",
      allRoles: "Tüm roller",
      sortBalanceAsc: "Bakiye (az → çok)",
      sortBalanceDesc: "Bakiye (çok → az)",
      upcomingLeave: "14 gün içinde izinli",
    },
    teamLeaves: {
      filters: {
        search: "Ad, kullanıcı adı, ekip veya izin türü ara...",
        allTeams: "Tüm ekipler",
        sortName: "Ada göre (A → Z)",
      },
      exportHint: "Ekranda listelenen izinler (sekme ve filtrelerle) aynı sırayla indirilir.",
    },
    leavesPage: {
      subtitle: "Taleplerinizi takip edin, bekleyenleri iptal edin veya düzenleyin.",
      pendingRequests: "Bekleyen talep",
      last30: "Son 30 gün kullanım",
      last365: "Son 365 gün kullanım",
      waitingDays: "gündür bekliyor",
      tabs: { all: "Tümü", pending: "Bekleyen", approved: "Onaylanan", closed: "Reddedilen / İptal" },
      filters: {
        search: "Tür, açıklama veya talep kodu ara...",
        searchTypes: "İzin türü ara...",
        type: "İzin türü",
        allTypes: "Tüm izin türleri",
        from: "Başlangıç ≥",
        to: "Bitiş ≤",
        sort: "Sırala",
      },
      sort: {
        createdDesc: "Talep tarihi (yeni → eski)",
        createdAsc: "Talep tarihi (eski → yeni)",
        startDesc: "İzin başlangıcı (uzak → yakın)",
        startAsc: "İzin başlangıcı (yakın → uzak)",
      },
      emptyFiltered: "Bu görünümde kayıt yok.",
    },
  },
  en: {
    teamLeavesPanel: { current: "On leave now", upcoming: "Upcoming" },
    holidays: {
      loadError: "Could not load holidays.",
      rangeInvalid: "End date cannot be before start date.",
      deleteConfirm: "Delete \"{{name}}\" ({{date}})?",
    },
    holidaysPage: {
      tabs: { all: "All", upcoming: "Upcoming", past: "Past" },
      search: "Search holiday name...",
      month: "Month",
      allMonths: "All months",
      weekday: "Day",
      weekend: "Weekend",
    },
    leaveTypesPage: {
      tabs: { all: "All", daily: "Daily", hourly: "Hourly", affects: "Deducts balance", noAffect: "No balance impact" },
      search: "Search leave type name or description...",
      sortNameAsc: "Name (A → Z)",
      sortNameDesc: "Name (Z → A)",
      nameRequired: "Leave type name is required.",
    },
    myTeamPage: {
      tabs: { all: "Whole team", onLeave: "On leave soon", lowBalance: "Low balance (≤3 days)" },
      search: "Search name, username or unit...",
      allRoles: "All roles",
      sortBalanceAsc: "Balance (low → high)",
      sortBalanceDesc: "Balance (high → low)",
      upcomingLeave: "On leave within 14 days",
    },
    teamLeaves: {
      filters: {
        search: "Search name, username, team or leave type...",
        allTeams: "All teams",
        sortName: "By name (A → Z)",
      },
      exportHint: "Downloads the leaves listed on screen (tab and filters), in the same order.",
    },
    leavesPage: {
      subtitle: "Track your requests, cancel or edit pending ones.",
      pendingRequests: "Pending requests",
      last30: "Used in last 30 days",
      last365: "Used in last 365 days",
      waitingDays: "days waiting",
      tabs: { all: "All", pending: "Pending", approved: "Approved", closed: "Rejected / Cancelled" },
      filters: {
        search: "Search type, reason or request code...",
        searchTypes: "Search leave types...",
        type: "Leave type",
        allTypes: "All leave types",
        from: "Start ≥",
        to: "End ≤",
        sort: "Sort",
      },
      sort: {
        createdDesc: "Requested (newest first)",
        createdAsc: "Requested (oldest first)",
        startDesc: "Leave start (latest first)",
        startAsc: "Leave start (soonest first)",
      },
      emptyFiltered: "No records in this view.",
    },
  },
};

export default leaves;
